import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--white-color)'}}>
      <Header />

      <main style={{flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 20px 80px', marginTop: '100px'}}>
        <div style={{maxWidth: 1100, width: '100%', textAlign: 'center'}}>
          <div style={{background: 'linear-gradient(180deg, rgba(var(--primary-color1-opc),0.15), rgba(15,61,58,0.04))', padding: '48px', borderRadius: 14, boxShadow: '0 20px 60px rgba(15,61,58,0.06)', border: '1px solid rgba(15,61,58,0.06)'}}>

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18}}>
              <div style={{width:120, height:120, borderRadius: '50%', background: 'var(--primary-color2)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontSize:36, fontWeight:700, boxShadow:'0 12px 30px rgba(15,61,58,0.18)', animation: 'float 3s ease-in-out infinite'}}>
                404
              </div>
            </div>

            <h1 style={{margin: '8px 0 6px', fontSize: '32px', color: 'var(--primary-color2)'}}>Page Not Found</h1>
            <p style={{color: 'var(--text-color)', marginBottom: 22, fontSize: '15px'}}>The page you requested does not exist or the URL is incorrect. We've redirected you here with the site header and footer so you can continue browsing.</p>

            <div style={{display: 'flex', gap: 14, justifyContent: 'center', marginBottom: 12}}>
              <Link to="/" style={{padding: '12px 20px', background: 'var(--primary-color2)', color:'#fff', borderRadius:8, textDecoration:'none', fontWeight:700}}>Go Home</Link>
              <Link to="/contact" style={{padding: '12px 20px', border: '2px solid var(--primary-color2)', color:'var(--primary-color2)', borderRadius:8, textDecoration:'none', fontWeight:700}}>Contact Us</Link>
            </div>

            <p style={{color:'#7a7a7a', marginTop:10, fontSize:13}}>Or try searching from the menu above — we kept the site header so navigation is available.</p>

            <style>{`@keyframes float { 0% { transform: translateY(0px); } 50% { transform: translateY(-8px); } 100% { transform: translateY(0px); } }
              @media (max-width: 768px) { main { margin-top: 80px !important; padding: 28px 12px 60px !important; } }
            `}</style>

          </div>

        

        </div>
      </main>

      <Footer />
    </div>
  );
}
